<script setup>
defineProps({
  class: "",
  hint: "",
  title: "",
});
</script>

<template>
  <h5 :class>{{ title }}
    <span>{{ hint }}</span>
  </h5>
</template>
